<template>
  <div class="fixed_page"  id="blurry">
    <div class="get-started">
      <div class="fixed_page">
        <div class="how_it_works_box on_top">
          <img src="/static/images/how_it_works/icon-HowItWorks.png">
          <h1>{{ getTranslations.visitor_visitor_header_how_it_works }}</h1>
          <p>
            {{ getTranslations.visitor_visitor_header_how_to_play }}
          </p>
        </div>
        <div class="circle_background">
          <div class="how_it_works_box second">
            <h1>{{ getTranslations.visitor_how_it_works_register }}</h1>
            <img src="/static/images/how_it_works/icon-Register.png" class="how_it_works_img">
            <p>
              {{ getTranslations.visitor_how_it_works_text }}
            </p>
            <hr>
            <h1>{{ getTranslations.visitor_how_it_works_play_game_and_win }}</h1>
            <img src="/static/images/how_it_works/icon-Play.png" class="how_it_works_img">
            <p>
              {{ getTranslations.visitor_how_it_works_play_game_and_win_text }}
            </p>

            <hr>
            <h1>{{ getTranslations.visitor_how_it_works_win_the_jackpot }}</h1>
            <img src="/static/images/how_it_works/icon-Prizes.png" class="how_it_works_img">
            <p>
              {{ getTranslations.visitor_how_it_works_win_the_jackpot_text }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint no-console: "off" */
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'howItWorks',
  data() {
    return {
      imageTop: '/ext/skin/top_icon.png',
    };
  },
  mounted() {
    /* eslint-disable */
    $(window).scroll(function (event) {
      var scroll = $(window).scrollTop();
      if(scroll > 500) {
        $('.goto-top').fadeIn();
      }
      else {
        $('.goto-top').fadeOut();
      }
    });
    /* eslint-enable */
    this.$nextTick(() => {
      /* eslint-disable */
      // initAccordion
      $('.toggle-accordion').click(function(e) {
        e.preventDefault();
        let $this = $(this);
        $('.toggle-accordion').removeClass('show');

        if ($this.next().hasClass('show')) {
          $this.next().removeClass('show');
          $this.removeClass('show');
          $this.next().slideUp(350);
        } else {
          $this.parent().parent().find('li .inner').removeClass('show');
          $this.parent().parent().find('li .inner').slideUp(350);
          $this.next().toggleClass('show');
          $this.addClass('show');
          $this.next().slideToggle(350);
        }
      });
      /* eslint-enable */
    });
  },
  methods: {
    imageErrorHandler() {
      this.imageTop = 'static/images/top_icon.png';
    },
    checkTopButton() {
      /* eslint-disable */
      $(window).scrollTop(0);
      /* eslint-enable */
    },
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/HowItWorks.vue